import { render, staticRenderFns } from "./NewConfirmationDialog.vue?vue&type=template&id=571ad64a&scoped=true"
import script from "./NewConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./NewConfirmationDialog.vue?vue&type=script&lang=js"
import style0 from "./NewConfirmationDialog.vue?vue&type=style&index=0&id=571ad64a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571ad64a",
  null
  
)

export default component.exports